import { signal } from "@preact/signals";

export type AppError = {
  id: string;
  title: string;
  message?: string;
};

/**
 * Stack of global application errors.
 * New errors are added to the stack and displayed in a modal.
 */
export const errorStack = signal<AppError[]>([]);

let errorIdCounter = 0;

/**
 * Show a global error dialog.
 * @param title - Short error title (e.g., "Failed to save")
 * @param message - Optional detailed message
 * @returns The error ID (can be used to dismiss programmatically)
 */
export function showError(title: string, message?: string): string {
  const id = `error-${++errorIdCounter}`;
  errorStack.value = [...errorStack.value, { id, title, message }];
  return id;
}

/**
 * Dismiss an error by ID.
 */
export function dismissError(id: string): void {
  errorStack.value = errorStack.value.filter((e) => e.id !== id);
}

/**
 * Dismiss the topmost error.
 */
export function dismissTopError(): void {
  if (errorStack.value.length > 0) {
    errorStack.value = errorStack.value.slice(0, -1);
  }
}

/**
 * Dismiss all errors.
 */
export function dismissAllErrors(): void {
  errorStack.value = [];
}
